// 'facet-filters-form' というカスタム要素が定義されるのを待ってから処理を開始
window.customElements.whenDefined('facet-filters-form').then(() => {

  // FacetFiltersFormクラスの、renderFiltersメソッドを新しい関数で上書き
  FacetFiltersForm.renderFilters = function(fetchedHtml, event) {
    const parsedHtml = new DOMParser().parseFromString(fetchedHtml, 'text/html');

    // 新しいHTMLから、モバイル用とPC用の両方のフィルター要素を全て取得
    const newFilterElements = parsedHtml.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

    // 取得した全ての新しいフィルター情報を使って、現在のページの表示を更新
    newFilterElements.forEach((newElement) => {
      const index = newElement.dataset.index;
      const oldElement = document.querySelector(`.js-filter[data-index="${index}"]`);
      if (!oldElement) return; // 対応する古い要素がなければ何もしない

      // --- ここからが今回の重要な修正部分 ---
      
      // 1. summary部分を更新（activeクラスの付け外しはここが担当）
      const newSummary = newElement.querySelector('.facets__summary');
      const oldSummary = oldElement.querySelector('.facets__summary');
      if (newSummary && oldSummary) {
        // innerHTMLではなくouterHTMLで置き換えることで、クラスの変更を確実にする
        oldSummary.outerHTML = newSummary.outerHTML;
      }

      // 2. フィルターの本体部分（チェックボックスや価格スライダー）を更新
      const newContent = newElement.querySelector('.facets__display');
      const oldContent = oldElement.querySelector('.facets__display');
      if (newContent && oldContent) {
        oldContent.innerHTML = newContent.innerHTML;
      }
    });

    // 元のコードにあった、選択中のフィルター表示などを更新する処理も呼び出す
    FacetFiltersForm.renderActiveFacets(parsedHtml);
    if (typeof FacetFiltersForm.renderAdditionalElements === 'function') {
      FacetFiltersForm.renderAdditionalElements(parsedHtml);
    }
  };

});


// mobile ドロワーチェックの調整
  function setupCheckboxStyles() {
    // 全てのフィルター項目を取得
    const facetItems = document.querySelectorAll('.mobile-facets__item');

    facetItems.forEach(item => {
      // 各項目の中にあるチェックボックスを探す
      const checkbox = item.querySelector('.mobile-facets__checkbox');
      if (checkbox) {
        // チェックボックスの状態に応じて、親のli要素に is-checked クラスを付け外しする
        if (checkbox.checked) {
          item.classList.add('is-checked');
        } else {
          item.classList.remove('is-checked');
        }
      }
    });
  }

  // ページが最初に読み込まれた時に実行
  document.addEventListener('DOMContentLoaded', setupCheckboxStyles);

  // フィルターがAJAXで更新された後にも実行 (Dawnテーマで重要)
  document.addEventListener('shopify:section:load', setupCheckboxStyles);
  
  // 念のため、クリックイベントでも監視
  document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('mobile-facets__checkbox')) {
      // 少し待ってから実行しないと、チェック状態の変更が間に合わない場合がある
      setTimeout(setupCheckboxStyles, 50);
    }
  });
